import { render, staticRenderFns } from "./createTncContent.vue?vue&type=template&id=233b1fb6&"
import script from "./createTncContent.vue?vue&type=script&lang=js&"
export * from "./createTncContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports